import React from 'react';
import { ServicesSection } from '../components/ServicesSection';
export function ServicesPage() {
  return <div data-id="element-1312">
      {/* Page Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden bg-black" data-id="element-1313">
        <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-1314" />
        <div className="relative z-10" data-id="element-1315">
          <p className="text-[#822433] font-bold text-sm uppercase tracking-widest mb-3" style={{
          color: '#CC0000'
        }} data-id="element-1316">
            What We Offer
          </p>
          <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-1317">
            Our Services
          </h1>
          <div className="w-12 h-0.5 mx-auto mt-4 mb-4" style={{
          background: '#FECB00'
        }} data-id="element-1318" />
          <p className="text-gray-400 text-base max-w-xl mx-auto" data-id="element-1319">
            Professional tire services for every vehicle — from daily drivers to
            heavy-duty trucks.
          </p>
        </div>
      </div>
      <ServicesSection data-id="element-1320" />
    </div>;
}